import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Northfield",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Northfield Minnesota college town in Rice County, historic downtown district with Division Street shops and restaurants, St. Olaf College campus with its distinctive architecture visible, Carleton College campus nearby, Cannon River flowing through the center of town, tree-lined residential streets, small-town Midwest charm with college-town character, daytime photography with clear sky, professional aerial photography, no readable signs or text",
  heroImageSeq: "northfield-mn-hero-2026",
  heroDescription:
    "Study abroad semester in three weeks and your passport expired? European heritage trip with six weeks to spare? Summer research program in Japan? We help Northfield residents — from St. Olaf and Carleton students and faculty to Rice County families and the historic downtown community — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.4583; -93.1616",
  geoPlacename: "Northfield, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/northfield/",
  localAreaTitle: "Serving Northfield & South Central Minnesota",
  localAreaText: [
    "Northfield, Minnesota is a vibrant college town in Rice County, located along the Cannon River about 40 miles south of the Twin Cities. The city is home to two prestigious liberal arts colleges — St. Olaf College (founded by Norwegian immigrants in 1874) and Carleton College (founded in 1866) — which give the town a unique intellectual and cultural character. The colleges employ thousands of faculty, staff, and attract students from across the country and around the world.",
    "The city's historic downtown along Division Street is the commercial and cultural heart of Northfield, featuring local shops, restaurants, and the iconic Archer House River Inn. The Defeat of Jesse James Days festival, held annually in September, draws thousands of visitors to commemorate the failed 1876 bank robbery attempt. The Cannon River provides scenic beauty and recreational opportunities throughout the city.",
    "Northfield's economy is anchored by the colleges, healthcare (Northfield Hospital), and a mix of manufacturing and small businesses. The city's location on Highway 3 and near I-35 provides access to the Twin Cities, Mankato, and Rochester. Many residents commute to the metro area for employment, while the colleges attract international students and visiting scholars.",
    "The study abroad programs at St. Olaf and Carleton are particularly robust, sending hundreds of students abroad each semester to Europe, Asia, Latin America, and Africa. These programs create a consistent demand for passport services — new first-time passports for students, renewals for faculty, and emergency processing for last-minute program acceptances. The academic calendar drives predictable travel patterns.",
  ],
  nearbyCities: [
    { name: "Northfield", zips: "55057" },
    { name: "Faribault", zips: "55021" },
    { name: "Dundas", zips: "55019" },
    { name: "Lonsdale", zips: "55046" },
    { name: "Owatonna", zips: "55060" },
    { name: "Farmington", zips: "55024" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Northfield home or dorm in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Northfield area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Northfield & South Central Minnesota",
  serviceAreaDescription: "Serving Rice County and south central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Northfield, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Northfield area post office can take 2–6 months — not suitable for upcoming study abroad programs.",
    },
    {
      q: "Can St. Olaf or Carleton students get passports before study abroad?",
      a: "Absolutely. Study abroad students are among our most common Northfield clients. We regularly process expedited first-time passports and renewals with compressed timelines — as fast as 2–9 business days. We understand academic deadlines and program acceptance timelines.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Northfield?",
      a: "No — most Northfield travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Northfield. You can ship from FedEx or UPS locations nearby in Northfield or Faribault.",
    },
    {
      q: "My study abroad program starts in four weeks. How early should I start my passport?",
      a: "We recommend starting immediately upon program acceptance. Most study abroad programs require passport validity for at least 6 months beyond the program end date. If you need a first-time passport, start as soon as you are accepted. If you need a renewal, start at least 6 weeks before departure.",
    },
    {
      q: "What if I was accepted to a study abroad program with only two weeks notice?",
      a: "Last-minute program acceptances happen. We can process your passport as fast as 24 hours with proof of travel. Our emergency service is designed for exactly these situations. Contact us immediately upon acceptance.",
    },
    {
      q: "Are there passport acceptance facilities near Northfield?",
      a: "The Northfield Post Office, Faribault Post Office, and Owatonna Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Northfield, MN — St. Olaf Student",
      rating: 5,
      text: "I was accepted to a study abroad program in Norway with three weeks notice. My passport had expired. Fast Passport Center processed my renewal in four business days. I made my program and spent an amazing semester in Oslo. The service was incredible and they understood the urgency of academic deadlines.",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Michael T.",
      location: "Northfield, MN — Carleton Faculty",
      rating: 5,
      text: "I received a conference invitation to present in Berlin with two weeks notice. My passport was expired. Fast Passport Center processed my renewal in three business days. I presented my research and it was a major career milestone. The team was professional and efficient.",
      service: "Emergency Renewal",
    },
    {
      name: "The Peterson Family",
      location: "Northfield, MN",
      rating: 5,
      text: "Our family planned a heritage trip to Norway to visit our ancestral village. We had six weeks. Fast Passport Center processed all four family passports in seven business days. The checklist made the process simple and we had a wonderful trip connecting with our roots. Highly recommend.",
      service: "Family Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Faribault", href: "/faribault" },
    { name: "Owatonna", href: "/owatonna" },
    { name: "Mankato", href: "/mankato" },
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "St. Paul", href: "/st-paul" },
    { name: "Rochester", href: "/rochester-mn" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Northfield",
  introDescription: "Fast passport processing for Northfield and south central Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Northfield and south central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Northfield Post Office",
      address: "519 Division St, Northfield, MN 55057",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(507) 663-0660",
      notes: "Primary passport acceptance facility for Northfield and Rice County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Faribault Post Office",
      address: "30 3rd St NW, Faribault, MN 55021",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 334-4311",
      notes: "Rice County seat. Full passport services. Good alternative for west Northfield residents.",
    },
    {
      name: "Owatonna Post Office",
      address: "300 W Broadway St, Owatonna, MN 55060",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 451-3730",
      notes: "Steele County seat. Full passport services. Convenient for south Northfield residents.",
    },
    {
      name: "Farmington Post Office",
      address: "219 Elm St, Farmington, MN 55024",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 463-7800",
      notes: "Dakota County. Full passport services. Convenient for north Northfield residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Northfield", address: "2100 Highway 3 S, Northfield, MN 55057", hours: "Call for hours" },
    { name: "CVS Pharmacy — Northfield", address: "1320 Bollenbacher Dr, Northfield, MN 55057", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Faribault", address: "200 Western Ave, Faribault, MN 55021", hours: "Call for hours" },
    { name: "CVS Pharmacy — Faribault", address: "700 4th St NW, Faribault, MN 55021", hours: "Daily 7 AM – 10 PM" },
    { name: "The UPS Store — Northfield", address: "Northfield commercial area", hours: "Call for hours" },
    { name: "FedEx Office — Owatonna", address: "Owatonna commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Rice County DVS Office",
      address: "320 NW 3rd St, Faribault, MN 55021",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Rice County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Steele County DVS — Owatonna",
      address: "630 Florence Ave, Owatonna, MN 55060",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Steele County DVS. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 45 miles from Northfield — 45–50 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary airport for Northfield residents. Full international flight service. Access via Highway 3 and I-35.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "About 55 miles from Northfield — 55–60 minutes by car",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Regional airport for Northfield residents. Direct flights to major hubs. International connections available.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "RST Airport Website",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "St. Olaf & Carleton Study Abroad",
      subtitle: "College students preparing for international academic programs",
      content:
        "St. Olaf and Carleton send hundreds of students abroad each semester. Study abroad programs span Europe, Asia, Latin America, and Africa. Students often discover passport issues when completing program paperwork 2–4 weeks before departure. First-time passports, renewals, and emergency processing are all common needs.",
      tip: "Study abroad students should check passport validity at least 6 months before program start. Most programs require 6+ months validity beyond the program end date.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Northfield Family Travel",
      subtitle: "Rice County families planning international vacations and heritage trips",
      content:
        "Northfield families plan international vacations regularly — Scandinavian heritage trips, European cultural tours, Caribbean cruises, and visits to relatives abroad. The academic calendar and summer break drive much of the family travel planning, with trips often booked during winter months for summer departure.",
      tip: "Check every family member's passport at least 8 weeks before any international trip. Children's passports expire in 5 years.",
      icon: "ri-parent-line",
    },
    {
      title: "Faculty & Academic Travel",
      subtitle: "College professors and researchers with international conference and research travel",
      content:
        "Northfield's college faculty regularly travel internationally for conferences, research collaborations, and sabbaticals. Conference invitations are often confirmed with 2–4 weeks notice, and research travel may require immediate departure for fieldwork or collaborative meetings.",
      tip: "Faculty should maintain current passport validity at all times. International conference invitations are often time-sensitive.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Scandinavian Heritage Travel",
      subtitle: "Norwegian heritage trips for Northfield's St. Olaf community and Scandinavian families",
      content:
        "Northfield's Norwegian heritage is deeply rooted in the St. Olaf community and Scandinavian Lutheran tradition. Heritage trips to Norway are particularly popular among St. Olaf students, alumni, and families. The college's Norwegian language programs and cultural events maintain strong connections to Scandinavian heritage.",
      tip: "St. Olaf's Norway programs are popular for January term and summer. Start passport renewals by October for winter programs.",
      icon: "ri-earth-line",
    },
  ],
  destinations: [
    {
      name: "Norway",
      context: "Study abroad, heritage travel, and cultural programs for St. Olaf students and families",
      urgency: "Study abroad programs have fixed start dates — passport must be ready",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises and resort vacations for Northfield families during academic breaks",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Resort vacations and cultural travel for Northfield families during winter and spring break",
      urgency: "Resort packages are often booked 3–4 weeks out during academic breaks",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Business travel for faculty conferences and research collaborations",
      urgency: "Conference schedules and research deadlines are fixed",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Japan",
      context: "Study abroad and research programs for Carleton and St. Olaf students",
      urgency: "Academic programs have fixed start dates",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "Study abroad programs and faculty research travel",
      urgency: "Academic programs and conferences have fixed schedules",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "38%", label: "of Northfield expedited requests are study abroad students with academic deadlines" },
    { stat: "2–4 Weeks", label: "most common advance notice when students discover passport issues before program start" },
    { stat: "Jan–May", label: "peak study abroad season for spring semester programs and summer travel planning" },
    { stat: "5–7 Days", label: "typical expedited processing time for Northfield clients choosing our recommended option" },
  ],
};

export default function NorthfieldMNPage() {
  return <CityPage data={data} />;
}